import { history } from "../_helpers";
export const workflowServices = {
  getAllWorkflow,
  getWorkflowById,
  getWorkflowTopCard,
  addWorkflow,
  editWorkflowById,
  addConfiguredWorkflowById,
  runWorkflowByJobId,
  getDatabricksJobStatus,
  searchWorkflow,
  getWorkflowFilters,
  applyWorkflowFilters,
  getGitRepoByConnectionId,
  activateWorkflow,
  getActiveWorkflowByConnectionId
};

function getAllWorkflow(offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getWorkflowById(workflowId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/${workflowId}`,
    requestOptions
  ).then(handleResponse);
}

function getWorkflowTopCard() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/topCards`,
    requestOptions
  ).then(handleResponse);
}

function addWorkflow(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow`,
    requestOptions
  ).then(handleResponse);
}

function editWorkflowById(workflowId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/${workflowId}`,
    requestOptions
  ).then(handleResponse);
}

function addConfiguredWorkflowById(workflowId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/configure/${workflowId}`,
    requestOptions
  ).then(handleResponse);
}

function runWorkflowByJobId(jobId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({ jobId }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/run/${jobId}`,
    requestOptions
  ).then(handleResponse);
}

function searchWorkflow(searchText, offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/search/${offset}/${limit}?searchText=${searchText}`,
    requestOptions
  ).then(handleResponse);
}

function getDatabricksJobStatus(runId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/databricks/job/status/${runId}`,
    requestOptions
  ).then(handleResponse);
}

function getWorkflowFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/filters/workflow`,
    requestOptions
  ).then(handleResponse);
}

function applyWorkflowFilters(
  connection,
  user,
  workspace,
  startDate,
  endDate,
  search,
  offset = 0,
  limit = 10
) {
  let userToken = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": userToken.accessToken,
    },
    body: JSON.stringify({
      connection,
      user,
      workspace,
      startDate,
      endDate,
      search,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/filter/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getGitRepoByConnectionId(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/connection/gitRepo/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function activateWorkflow(isActive, workflowId, workflowName) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      isActive,
      workflowName,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/activate/${workflowId}`,
    requestOptions
  ).then(handleResponse);
}


function getActiveWorkflowByConnectionId(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workflow/active/connection/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        // redirecting to signin page
        history.push("/auth/signin");
        // removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
